import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function ContractsPage() {
  return (
    <MainLayout>
      <SEO 
        title="Contratos"
        description="Gerencie contratos de serviços"
        keywords="contratos, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Contratos</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

